export const qiniuConfig = {
  uploadHost: process.env.REACT_APP_QINIU_UPLOAD_HOST,
  downloadHost: process.env.REACT_APP_QINIU_DOWNLOAD_HOST,
  getFullURL: (key) => `${process.env.REACT_APP_QINIU_DOWNLOAD_HOST}/${key}`
};
